// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import jaCommon from '../../locales/ja/translation.clean.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            ja: {
                common: jaCommon
            }
        },
        lng: 'ja',
        fallbackLng: 'en',
        ns: ['common'],
        defaultNS: 'common',
        interpolation: {
            escapeValue: true
        }
    });

export default i18n;
